__turbopack_context__.v({
  "actions": "NoProjectsFallback-module-scss-module__DggHDG__actions",
  "content": "NoProjectsFallback-module-scss-module__DggHDG__content",
  "illustration": "NoProjectsFallback-module-scss-module__DggHDG__illustration",
  "title": "NoProjectsFallback-module-scss-module__DggHDG__title",
  "wrapper": "NoProjectsFallback-module-scss-module__DggHDG__wrapper",
});
